import React from 'react';

import { IconButton, Tooltip } from '@mui/material';

type Props = {
  placement: 'top' | 'left-start';
  tooltipTitle: string;
  disabled?: boolean;
  children: JSX.Element;
  onClick: () => void;
};
export default function TuneMenuButton({ tooltipTitle, disabled, children, onClick, placement }: Props) {
  const p = placement === 'left-start' ? 'right' : 'top';
  return (
    <Tooltip title={tooltipTitle} placement={p}>
      <span>
        <IconButton disabled={disabled} onClick={onClick} sx={{ color: 'text.primary' }}>
          {children}
        </IconButton>
      </span>
    </Tooltip>
  );
}
